/**
 * «Criar artigo com stock (arquiva este)» (0.44.0) — as decisões do ecrã, sem
 * React, para os testes: que artigo da pesquisa leva o botão, o que vai no
 * pedido (`expected` = o que se mostrou) e o que se diz depois.
 *
 * Quem tem a área Armazém pode fazê-lo (decisão de 16/10): o servidor só
 * verifica a área; o host recusa entregas/receções em curso, variantes e
 * falta de grupos no Odoo.
 */
import type { ScanFeedback } from "@/components/scanner/Scanner"
import type { PickProduct, ReplaceProductOutcome } from "./ronda-api"

/** Só os artigos sem controlo de stock no Odoo («Rastrear inventário» desligado). */
export function canReplaceProduct(p: Pick<PickProduct, "storable">): boolean {
  return p.storable === false
}

/** «[REF] Nome» → «Nome» (o `display_name` do Odoo), quando a pesquisa não trouxe o `name`. */
export function bareName(name: string | null, defaultCode: string | null): string | null {
  if (!name) return null
  if (defaultCode && name.startsWith(`[${defaultCode}] `)) return name.slice(defaultCode.length + 3)
  return name
}

/** O pedido: o artigo e o que a pesquisa mostrou (se mudou no Odoo entretanto, o host recusa). */
export function replaceRequestFor(p: Pick<PickProduct, "id" | "name" | "odoo_name" | "default_code">) {
  return { product_id: p.id, expected: { default_code: p.default_code ?? null, name: p.odoo_name ?? bareName(p.name, p.default_code) } }
}

export const REPLACE_TOAST = "Artigo novo criado no Odoo (stock a 0) — conte-o"

/** Depois de criar: uma faixa com o que aconteceu e uma por aviso (do host ou da app). */
export function replaceFeedback(out: Pick<ReplaceProductOutcome, "product" | "warnings">): ScanFeedback[] {
  const name = out.product.name ?? `Artigo ${out.product.id}`
  return [
    ...out.warnings.map((w): ScanFeedback => ({ tone: "warn", text: w })),
    { tone: "ok", text: `${name}: artigo novo com stock no Odoo (o antigo ficou arquivado). Conte-o agora.` },
  ]
}
